import { Link } from "react-router-dom";
import React from "react";
export const Entry = () => {
    return (React.createElement("section", { className: "entry" },
        React.createElement("h3", null, "Was f\u00FCr ein Schiff m\u00F6chten Sie besichtigen?"),
        React.createElement("div", { className: "entry-boxes" },
            React.createElement(Link, { to: "/fluss", className: "entry-box" },
                React.createElement("i", { className: "fas fa-ship f2" }),
                React.createElement("br", null),
                "Flussschiff"),
            React.createElement(Link, { to: "/see", className: "entry-box" },
                React.createElement("i", { className: "fas fa-ship f2" }),
                React.createElement("br", null),
                "Hochseeschiff"))));
};
export default Entry;
